module.exports = __webpack_public_path__ + "static/media/testfiles_objectSelection.36915298.zip";